/**
 * On click changes the value of the input.
 */
const $minus = $('.js-minus');

$minus.click(function () {
	const $this = $(this);
	const $input = $this.siblings('input');

	let count = parseInt($input.val()) - 1;
	count = count < 1 ? 1 : count;
	$input.val(count);
	$input.change();

	return false;
});

/**
 * On click changes the value of the input.
 */

const $plus = $('.js-plus')

$plus.click(function () {
	const $this = $(this);
	const $input = $this.siblings('input');

	$input.val(parseInt($input.val()) + 1);
	$input.change();

	return false;
});
